
import React, { useEffect, useState } from "react";
import Header from "components/Header";
import SoftInput from "components/SoftInput";
import ActionItem from "components/ActionItem";
import NumberCards from "components/NumberCards";
import BirthsCard from "components/BirthCards";
import ANCDataCard from "components/ANCData";
import DeliveriesData from "components/DeliveryData";
import NewBornCard from "components/NewBornCard"
import NCDDataCard from "components/NCDData"
import HealthNCDCharts from "components/HealthNCDCharts"
import DeathsGroupedChart from "components/ChildDeaths"
import SingleFacilityCard from "components/FacilityTypesV2"
import FullyImmunizedCard from "components/FullyImmunizedCard"
import SAMCard from "components/SAM";
import MaternalDeathsPieChart from "components/MaternalDeath";
import DashboardMap from "components/MaharashtraMap";
import AlertsPanel from "components/FacilityAlerts";
import TBDataCard from "components/TBDataCard"
// import stateGeoJSON from "public/geojson/1.geojson";

import { DEFAULT_BIRTHS } from 'components/BirthCards';

import CancerScreeningCard from "components/cancer"
import {
	FaUsers,        // Population
	FaMapMarkedAlt, // District
	FaCity,         // Tehsil
	FaMapSigns,     // Block
	FaHome,         // Gram Panchayat
	FaTree,         // Village
	FaLocation         // location
} from "react-icons/fa";
// import { GeoJSON } from 'react-leaflet';

// import districtsGeoJSON from "./geo/districts.geojson";
// import blocksGeoJSON from "./geo/blocks.geojson";
const now = new Date();

const alertsData = [
	{
		id: "1",
		type: "success",
		title: "Vaccination Completed",
		message: "All scheduled vaccines administered in Mumbai",
		timeStamp: "2 hours ago",
	},
	{
		id: "2",
		type: "warning",
		title: "Low Stock of Medicines",
		message: "Stock of Paracetamol below threshold in 3 PHCs",
		timeStamp: "8 hours ago",
	},
	{
		id: "3",
		type: "alert",
		title: "New COVID Cases Detected",
		message: "5 new cases detected in Nashik",
		timeStamp: "1 day ago",
	},
	{
		id: "4",
		type: "info",
		title: "Annual Health Survey",
		message: "Survey started in Pune, 150 families enrolled",
		timeStamp: "3 days ago",
	},
];


const healthCareData = [
	{
		icon: <FaUsers />,
		title: "Population",
		value: "1,12,374,333",
		sub: "(Census 2011)",
		color: "#1976D2",
	},
	{
		icon: <FaMapMarkedAlt />,
		title: "District",
		value: "36",
		color: "#1976D2",
	},
	{
		icon: <FaCity />,
		title: "Taluka",
		value: "358",
		color: "#1976D2",
	},
	{
		icon: <FaMapSigns />,
		title: "Block",
		value: "352",
		color: "#1976D2",
	},
	{
		icon: <FaHome />,
		title: "Gram Panchayat",
		value: "28,349",
		color: "#1976D2",
	},
	{
		icon: <FaTree />,
		title: "Village",
		value: "44,753",
		color: "#1976D2",
	},
];
export const districtHealthCareData = [
	{ icon: <FaUsers />, title: "Population", value: "1,28,61,024", sub: "(Census 2011)", color: "#1976D2" },
	{ icon: <FaMapMarkedAlt />, title: "District", value: "1", color: "#1976D2" },
	{ icon: <FaCity />, title: "Taluka", value: "12", color: "#1976D2" },
	{ icon: <FaMapSigns />, title: "Block", value: "10", color: "#1976D2" },
	{ icon: <FaHome />, title: "Gram Panchayat", value: "5,670", color: "#1976D2" },
	{ icon: <FaTree />, title: "Village", value: "9,031", color: "#1976D2" },
];
const facilities = [
	// { id: 1, name: "PHC A", lat: 26.9, lng: 80.9, type: "PHC", metric: "ICU: 0" },
	// { id: 2, name: "CHC B", lat: 27.1, lng: 79.9, type: "CHC", metric: "ICU: 2" },
];

function HealthcareInfrastructureDashboard() {
	const [districtView, setDistrictView] = useState(null);
	const [seed, setSeed] = useState(0);
	const [currentBirths, setCurrentBirths] = useState(DEFAULT_BIRTHS);
	const [stateGeoJSON, setStateGeoJSON] = useState(null);
	useEffect(() => {
		fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // state polygon
			.then((res) => res.json())
			.then((data) => setStateGeoJSON(data))
			.catch((err) => console.error("GeoJSON load error:", err));
	}, []);

	const [districtsGeoJSON, setdistrictsGeoJSON] = useState(null);
	useEffect(() => {
		fetch(process.env.PUBLIC_URL + "/geojson/1.geojson") // <- all districts
			.then((res) => res.json())
			.then((data) => setdistrictsGeoJSON(data))
			.catch((err) => console.error("GeoJSON load error:", err));
	}, []);
	const handleMenuClick = () => {
		// alert("Sidebar opened! (You can link this to real sidebar)");
	};

	const [searchQuery, setSearchQuery] = useState("");
	const [selected, setSelected] = useState("");

	return (
		<>
			<Header
				onMenuClick={handleMenuClick}
				selected={selected}
				setSelected={setSelected}
				onSearchChange={setSearchQuery}
				dashboardName="Maharashtra Healthcare Dashboard"
			/>

			<div className="dashboard-wrapper">
				<div className="dashboard-content">
					<div className="container-fluid p-2">

						{/* Top section */}
						<div className="row g-3">

							{/* Left column */}
							<div className="col-12 col-md-auto d-flex flex-column gap-1">
								<NumberCards
									healthCareData={districtView ? districtHealthCareData : healthCareData}
									selectedDistrict={districtView}
									seed={0.2}
								/>
								<SingleFacilityCard seed={districtView ? 0.2 : 1} />
							</div>

							{/* Map */}
							<div className="col-12 col-md flex-grow-1">
								<DashboardMap
									stateGeoJSON={stateGeoJSON}
									districtsGeoJSON={districtsGeoJSON}
									initialView={{
										lat: 19.663280,
										lng: 75.300293,
										zoom: 6,
										minZoom: 6,
										maxZoom: 10
									}}
									onDistrictClick={(name) => {
										setDistrictView(name);
										setSeed((s) => s + 1);
									}}
								/>
							</div>

							{/* Right column */}
							<div className="col-12 col-lg-6 d-flex flex-column">
								<div className="row g-2">
									<div className="col-12 col-md-4"><BirthsCard selectedDistrict={districtView} seed={seed} /></div>
									<div className="col-12 col-md-4"><ANCDataCard selectedDistrict={districtView} seed={seed} /></div>
									<div className="col-12 col-md-4"><DeliveriesData selectedDistrict={districtView} seed={seed} /></div>
								</div>
								<div className="row g-2">
									<div className="col-md-7 col-xl-6 col-sm-12 ">
										<HealthNCDCharts selectedDistrict={districtView} seed={seed} />
									</div>
									<div className="col-md-5 col-xl-6 col-sm-12 ">
										<AlertsPanel alerts={alertsData} />
									</div>
								</div>
							</div>
						</div>

						{/* Middle section */}
						<div className="row g-2 mt-0">
							<div className="col-12 col-sm-6 col-md-4 col-lg"><NewBornCard selectedDistrict={districtView} seed={seed} /></div>
							<div className="col-12 col-sm-6 col-md-4 col-lg"><FullyImmunizedCard selectedDistrict={districtView} seed={seed} /></div>
							<div className="col-12 col-sm-6 col-md-4 col-lg"><SAMCard selectedDistrict={districtView} seed={seed} /></div>
							<div className="col-12 col-sm-6 col-md-4 col-lg"><CancerScreeningCard selectedDistrict={districtView} seed={seed} /></div>
							<div className="col-12 col-sm-6 col-md-4 col-lg"><NCDDataCard selectedDistrict={districtView} seed={seed} /></div>
							<div className="col-12 col-sm-6 col-md-4 col-lg"><TBDataCard selectedDistrict={districtView} seed={seed} /></div>
						</div>

						{/* Bottom Section */}
						<div className="row g-1 mt-1">
							<div className="col-12 col-md-6"><DeathsGroupedChart selectedDistrict={districtView} seed={seed} /></div>
							<div className="col-12 col-md-6"><MaternalDeathsPieChart selectedDistrict={districtView} seed={seed} /></div>
						</div>

					</div>
				</div>
			</div>

		</>

	)
}
export default HealthcareInfrastructureDashboard;